import { zmgPublicCacheClient } from '../zmg_cache';
import { getSupportPartnerInfo } from '../helpers_website/zmg_cache_website';
import { DEFAULT_PLATFORM_SERVICE_FEE } from '@lib/platformServiceFee';
import type { ServiceFee } from '@lib/zod/serviceFee';

export const getDeliveryteamPlatformServiceFee = async (
    deliveryteamId?: string | null,
): Promise<ServiceFee | null> => {
    if (deliveryteamId) {
        const override = (await (await zmgPublicCacheClient.deliveryteam.platform_service_fee_override[':id']['data.json'].$get({
            param: { id: deliveryteamId }
        })).json()).data?.overridePlatformServiceFee;
        if (override) {
            return override;
        }
    }
    return DEFAULT_PLATFORM_SERVICE_FEE;
};

export const get_storeSupportWebsiteId_by_deliveryteamId = async (deliveryteamId: string) => {
    return (await (await zmgPublicCacheClient.deliveryteam.deliveryteam_partner_website_info[':id']['data.json'].$get({
        param: { id: deliveryteamId }
    })).json()).data?.deliveryteamSupportWebsiteId;
}

export const getSupportTeamFee_deliveryteam = async (deliveryteamId: string) => {
    const deliveryteamSupportWebsiteId = await get_storeSupportWebsiteId_by_deliveryteamId(deliveryteamId);
    if (!deliveryteamSupportWebsiteId) {
        return null;
    }
    const supportTeamWebsitePartnerInfo = await getSupportPartnerInfo(deliveryteamSupportWebsiteId);
    if (!supportTeamWebsitePartnerInfo?.isSupportTeamPartner) {
        return null;
    }
    const feeOverride = (await (await zmgPublicCacheClient.website.fee_override_as_deliveryteam_support_team[':id'][':cId']['data.json'].$get({
        param: { id: deliveryteamSupportWebsiteId, cId: deliveryteamId }
    })).json()).data?.overridePartnerFee;
    return {
        deliveryteamSupportWebsiteId: deliveryteamSupportWebsiteId,
        fee: feeOverride || supportTeamWebsitePartnerInfo?.defaultSupportPartnerFee || null
    };
}

export const get_support_team_info_of_deliveryteam = async (deliveryteamId: string) => {
    const deliveryteamSupportWebsiteId = await get_storeSupportWebsiteId_by_deliveryteamId(deliveryteamId);
    if (!deliveryteamSupportWebsiteId) {
        return null;
    }
    const supportTeamWebsitePartnerInfo = await getSupportPartnerInfo(deliveryteamSupportWebsiteId);
    if (!supportTeamWebsitePartnerInfo?.isSupportTeamPartner) {
        return null;
    }
    return supportTeamWebsitePartnerInfo;
}
